import React from 'react';

import {AuthProvider} from "features/auth";
import AppRouter from "./AppRouter";

class ErrorBoundary extends React.Component<{children: React.ReactNode}, {error: Error | null}> {
    state = { error: null };
    static getDerivedStateFromError(error: Error) { return { error }; }
    render() {
        if (this.state.error) return <pre style={{color:'red',padding:20}}>{(this.state.error as Error).message}{'\n'}{(this.state.error as Error).stack}</pre>;
        return this.props.children;
    }
}

const App: React.FC = () => (
    <ErrorBoundary>
        <AuthProvider>
            <AppRouter />
        </AuthProvider>
    </ErrorBoundary>
);

export default App;
